<template>
    <div>
        <modal name="list-actions" :scrollable="true" height="auto">
            <div class="modal-content">

              <div class="modal-header">
                  <h5 class="modal-title">Selected devices</h5>
                    <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
              </div>

              <div class="modal-body">
                  <div class="panel-group">

                  </div>
              </div>

              <div class="modal-footer">
                  <button type="button" class="btn btn-primary" @click="closeModal">LEAVE</button>
              </div>
            </div>
        </modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'ActionsModal',
    components: {
    },
    props: {
        selectedDevices: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data () {
        return {
            tasks: [
                {
                    task: 'reboot',
                    name: 'reboot devices',
                    installer: true
                },
                {
                    task: 'update',
                    name: 'update devices',
                    installer: true
                },
                {
                    task: 'checkstatus',
                    name: 'check status for all selected devices',
                    shops: true,
                    button: {
                        text: 'configure'
                    }
                },
                {
                    task: 'update-enable',
                    name: 'enable updates',
                    task: 'envs',
                    name: 'configure settings to all selected shops',
                    shops: true,
                    button: {
                        text: 'configure'
                    }
                }
            ]
        }
    },
    methods: {
        closeModal(){
            this.$modal.hide('list-actions');
            this.tasksGenerated = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.label-input {
  float: none;
}
.panel{
   .panel-heading{
      min-height: 24px;
      padding-top: 3px;
      padding-bottom: 3px;
      h5{
        font-size: 24px;
        margin-bottom: 0;
        line-height: 30px;
      }
    }
    &.panel-success {
      color: #155724;
      background-color: #d4edda;
      border-color: #c3e6cb;
    }
    &.panel-warning {
      color: #856404;
      background-color: #fff3cd;
      border-color: #ffeeba;
    }

    &.actions {
      ul{
        list-style-type: none;
        padding-inline-start: 0;
      }
    }
  }
</style>
